'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _slIcon_blank = require('../../img/icon/sl-icon_blank.svg');

var _slIcon_blank2 = _interopRequireDefault(_slIcon_blank);

var _SLDummy = require('../../img/SL-Dummy.jpg');

var _SLDummy2 = _interopRequireDefault(_SLDummy);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formStep = require('../../container/steps/formStep');

var _formStep2 = _interopRequireDefault(_formStep);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactSpinkit = require('react-spinkit');

var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MobilityElement = function (_React$Component) {
  _inherits(MobilityElement, _React$Component);

  function MobilityElement(props) {
    _classCallCheck(this, MobilityElement);

    var _this = _possibleConstructorReturn(this, (MobilityElement.__proto__ || Object.getPrototypeOf(MobilityElement)).call(this, props));

    _this.state = {
      id: _underscore2.default.uniqueId("mobility-")
    };
    return _this;
  }

  _createClass(MobilityElement, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var imageUrl = this.props.mobility.ImageId ? _config2.default.getKey("imageUrl") + this.props.mobility.ImageId : _slIcon_blank2.default;
      return _react2.default.createElement('div', {
        className: 'group'
      }, _react2.default.createElement('div', {
        className: 'line'
      }, _react2.default.createElement('div', {
        className: 'txt'
      }, _react2.default.createElement('div', {
        className: 'img icon'
      }, _react2.default.createElement('img', {
        src: imageUrl
      })), _react2.default.createElement('p', null, this.props.mobility.Name)), _react2.default.createElement('div', {
        className: 'right'
      }, _react2.default.createElement('span', {
        className: 'switch'
      }, _react2.default.createElement('input', {
        type: 'checkbox',
        id: this.state.id,
        checked: this.props.isSelected,
        onChange: function onChange() {
          return _this2.props.selectMobility();
        }
      }), _react2.default.createElement('label', {
        htmlFor: this.state.id
      }, _react2.default.createElement('span', null))))));
    }
  }]);

  return MobilityElement;
}(_react2.default.Component);

MobilityElement.propTypes = {
  mobility: _propTypes2.default.object.isRequired,
  selectMobility: _propTypes2.default.func.isRequired,
  isSelected: _propTypes2.default.bool.isRequired
};

var ServiceSelector = function (_React$Component2) {
  _inherits(ServiceSelector, _React$Component2);

  function ServiceSelector(props) {
    _classCallCheck(this, ServiceSelector);

    var _this3 = _possibleConstructorReturn(this, (ServiceSelector.__proto__ || Object.getPrototypeOf(ServiceSelector)).call(this, props));

    _this3.state = {
      mobilityId: null
    };
    return _this3;
  }

  _createClass(ServiceSelector, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.enableSubmit();
    }
  }, {
    key: 'getFormData',
    value: function getFormData() {
      return {
        stepId: "mobility",
        formData: {
          mobilityId: this.state.mobilityId
        }
      };
    }
  }, {
    key: 'onSelectMobility',
    value: function onSelectMobility(mobility) {
      var mobilityId = this.state.mobilityId === mobility.Id ? null : mobility.Id;
      this.setState({
        mobilityId: mobilityId
      });
    }
  }, {
    key: 'renderServiceSelectors',
    value: function renderServiceSelectors() {
      var _this4 = this;

      var selectors = [];

      var _loop = function _loop(mobilityId) {
        var mobility = _this4.props.mobilitys[mobilityId];
        var b = _this4.state.mobilityId === mobility.Id;
        selectors.push(_react2.default.createElement(MobilityElement, _extends({}, _this4.props, {
          mobility: mobility
        }, {
          key: mobilityId,
          selectMobility: function selectMobility() {
            return _this4.onSelectMobility(mobility);
          },
          isSelected: b
        })));
      };

      for (var mobilityId in this.props.mobilitys) {
        _loop(mobilityId);
      }

      return selectors;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', null, _react2.default.createElement('div', {
        className: 'sub'
      }, 'Auswahl Ersatzmobilit\xE4t'), !Object.keys(this.props.mobilitys).length && _react2.default.createElement('p', null, 'Keine Mobilit\xE4tsalternative gefunden'), this.renderServiceSelectors());
    }
  }]);

  return ServiceSelector;
}(_react2.default.Component);

ServiceSelector.propTypes = {
  mobilitys: _propTypes2.default.array.isRequired,
  mobilityIds: _propTypes2.default.array.isRequired
};
exports.default = (0, _formStep2.default)(ServiceSelector);